import * as React from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import NavigationListGroupItem from './NavigationListGroupItem';
import NavigationListDistrictGroupItem from './NavigationListDistrictGroupItem';
import NavigationListRootGroupItem from './NavigationListRootGroupItem';
import NavigationListOrganizationItem from './NavigationListOrganizationItem';

import { NavigationList_me_navigationSections_items } from 'queries/__generated__/NavigationList';

type Props = {
  items: NavigationList_me_navigationSections_items[];
  isDistrictSection?: boolean;
};

class NavigationListSectionItems extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props): boolean {
    return shallowCompare(this, nextProps, undefined);
  }

  renderItem = (item: NavigationList_me_navigationSections_items) => {
    switch (item.__typename) {
      case 'Class': {
        if (!this.props.isDistrictSection) {
          return <NavigationListGroupItem group={item} key={item.uuid} />;
        }
        return <NavigationListDistrictGroupItem group={item} key={item.uuid} />;
      }
      case 'Organization': {
        return <NavigationListOrganizationItem organization={item} key={item.uuid} />;
      }
      case 'NavigationSectionItemRootClass': {
        return <NavigationListRootGroupItem item={item} key="all" />;
      }
      default: {
        console.warn(item);
        console.error('NavigationListSectionItems - unsupported type');
        return null;
      }
    }
  };

  render() {
    const { items } = this.props;

    return <ul className="NavigationListSectionItems">{items.map(this.renderItem)}</ul>;
  }
}

export default NavigationListSectionItems;
